"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AccountSelectV = require("./AccountSelectV2");
Object.keys(_AccountSelectV).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AccountSelectV[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AccountSelectV[key];
    }
  });
});